/**
 * 학폭 생기부 기재 가이드 - SEO 롱테일 페이지
 * 
 * 타겟 키워드: 학폭 생기부 기재, 학교폭력 생기부, 학폭 조치사항 기재, 학폭 기재 삭제
 */

import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Footer from '../../components/layout/Footer';
import '../../styles/design-system/index.css';

const HakpokGijaeGuidePage = () => {
  const navigate = useNavigate();

  const measures = [
    { num: '1호', content: '서면사과', period: '졸업과 동시 삭제', gijae: '기재하지 않음' },
    { num: '2호', content: '접촉·협박·보복행위 금지', period: '졸업과 동시 삭제', gijae: '기재하지 않음' },
    { num: '3호', content: '학교봉사', period: '졸업과 동시 삭제', gijae: '기재하지 않음' },
    { num: '4호', content: '사회봉사', period: '졸업 후 2년', gijae: '학적사항 특기사항' },
    { num: '5호', content: '특별교육이수 또는 심리치료', period: '졸업 후 2년', gijae: '학적사항 특기사항' },
    { num: '6호', content: '출석정지', period: '졸업 후 2년', gijae: '학적사항 특기사항 + 출결상황' },
    { num: '7호', content: '학급교체', period: '졸업 후 2년', gijae: '학적사항 특기사항' },
    { num: '8호', content: '전학', period: '졸업 후 4년', gijae: '학적사항 특기사항' },
    { num: '9호', content: '퇴학처분', period: '삭제 불가', gijae: '학적사항 특기사항' }
  ];

  const faqItems = [
    {
      q: '학폭 조치를 받으면 무조건 생기부에 기재되나요?',
      a: '아닙니다. 1~3호(서면사과, 접촉금지, 학교봉사) 조치는 생기부에 기재하지 않습니다. 4호 이상 조치만 학적사항 특기사항에 기재됩니다.'
    },
    {
      q: '학폭 기재 삭제는 어떻게 하나요?',
      a: '조치별로 정해진 보존 기간이 지나면 자동 삭제됩니다. 다만, 졸업 전 삭제를 원하는 경우 학교폭력대책심의위원회에 삭제 심의를 요청할 수 있습니다.'
    },
    {
      q: '삭제된 기록도 대학에서 볼 수 있나요?',
      a: '아닙니다. 삭제된 기록은 학생부에서 완전히 제거되어 대학 제출용 학생부에는 나타나지 않습니다.'
    },
    {
      q: '학폭 기재 삭제 심의 기준은?',
      a: '반성 정도, 긍정적 행동 변화, 피해학생과의 화해 여부, 학교생활 개선 노력 등을 종합적으로 고려합니다.'
    }
  ];

  return (
    <>
      <Helmet>
        <title>학폭 생기부 기재 완전정리 | 조치별 기재사항·삭제시기·삭제심의</title>
        <meta name="description" content="학교폭력 생기부 기재 기준 완전 정리. 조치별(1~9호) 기재 여부, 보존기간, 삭제 시기. 학폭 기재 삭제 심의 요청 방법과 기준. 교사용 실무 가이드." />
        <meta name="keywords" content="학폭 생기부 기재, 학교폭력 생기부, 학폭 조치사항 기재, 학폭 기재 삭제, 학폭 보존기간, 학교폭력대책심의위원회, 학폭 조치 종류, 학생부 학폭 기재" />
        <link rel="canonical" href="https://whatquiz.co.kr/guide/hakpok-gijae" />
        
        <meta name="robots" content="index, follow" />
        
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://whatquiz.co.kr/guide/hakpok-gijae" />
        <meta property="og:title" content="학폭 생기부 기재 완전정리 | 조치별 기재·삭제 시기" />
        <meta property="og:description" content="학교폭력 조치별 생기부 기재 기준. 1~9호 조치 보존기간과 삭제 심의 방법." />
        <meta property="og:image" content="https://whatquiz.co.kr/og-image-whatquiz-2025.png?v=20260210" />
        <meta property="og:locale" content="ko_KR" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.map(item => ({
              "@type": "Question",
              "name": item.q,
              "acceptedAnswer": { "@type": "Answer", "text": item.a }
            }))
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "학폭 생기부 기재 완전정리",
            "description": "학교폭력 조치별 생기부 기재 기준, 보존기간, 삭제 심의 가이드",
            "author": { "@type": "Organization", "name": "왓퀴즈" },
            "publisher": { "@type": "Organization", "name": "왓퀴즈" },
            "datePublished": "2026-02-05",
            "dateModified": "2026-02-05"
          })}
        </script>
      </Helmet>

      <div style={{ 
        fontFamily: 'var(--whatquiz-font-family)',
        backgroundColor: '#fff',
        minHeight: '100vh'
      }}>
        {/* 히어로 */}
        <section style={{
          padding: '80px 20px 60px',
          textAlign: 'center',
          background: 'linear-gradient(180deg, #fef3c7 0%, #fff 100%)'
        }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <span style={{
              display: 'inline-block',
              padding: '6px 16px',
              backgroundColor: '#fde68a',
              color: '#92400e',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: '600',
              marginBottom: '16px'
            }}>
              교사용 실무 가이드
            </span>
            
            <h1 style={{
              fontSize: 'clamp(26px, 5vw, 40px)',
              fontWeight: '800',
              color: '#111',
              lineHeight: '1.3',
              marginBottom: '20px'
            }}>
              학폭 생기부 기재<br />
              <span style={{ color: '#d97706' }}>완전 정리</span>
            </h1>
            
            <p style={{
              fontSize: '17px',
              color: '#64748b',
              lineHeight: '1.7',
              marginBottom: '32px'
            }}>
              조치별 기재사항, 보존기간, 삭제 심의까지<br />
              <strong>한눈에 파악하세요</strong>
            </p>
          </div>
        </section>

        {/* 조치별 기재사항 표 */}
        <section style={{
          padding: '60px 20px',
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#111',
            marginBottom: '24px',
            textAlign: 'center'
          }}>
            조치별 기재사항 & 보존기간
          </h2>

          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '14px'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f8fafc' }}>
                  <th style={{ padding: '14px 12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0', fontWeight: '600' }}>조치</th>
                  <th style={{ padding: '14px 12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0', fontWeight: '600' }}>내용</th>
                  <th style={{ padding: '14px 12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0', fontWeight: '600' }}>보존기간</th>
                  <th style={{ padding: '14px 12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0', fontWeight: '600' }}>기재 위치</th>
                </tr>
              </thead>
              <tbody>
                {measures.map((item, idx) => (
                  <tr key={idx} style={{ 
                    backgroundColor: idx < 3 ? '#ecfdf5' : idx === 8 ? '#fef2f2' : '#fff'
                  }}>
                    <td style={{ 
                      padding: '12px', 
                      borderBottom: '1px solid #e5e7eb',
                      fontWeight: '600',
                      color: idx < 3 ? '#047857' : idx === 8 ? '#dc2626' : '#374151'
                    }}>
                      {item.num}
                    </td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e5e7eb', color: '#374151' }}>
                      {item.content}
                    </td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #e5e7eb', color: '#374151' }}>
                      {item.period}
                    </td>
                    <td style={{ 
                      padding: '12px', 
                      borderBottom: '1px solid #e5e7eb',
                      color: idx < 3 ? '#047857' : '#374151'
                    }}>
                      {item.gijae}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{
            marginTop: '16px',
            padding: '16px',
            backgroundColor: '#f0fdf4',
            borderRadius: '8px',
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap'
          }}>
            <span style={{ fontSize: '13px', color: '#047857' }}>
              <strong>✓ 1~3호:</strong> 생기부에 기재하지 않음 (졸업과 동시 자동 삭제)
            </span>
            <span style={{ fontSize: '13px', color: '#dc2626' }}>
              <strong>9호:</strong> 퇴학처분은 영구 보존 (삭제 불가)
            </span>
          </div>
        </section>

        {/* 기재 문구 예시 */}
        <section style={{
          padding: '60px 20px',
          backgroundColor: '#f8fafc'
        }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#111',
              marginBottom: '24px',
              textAlign: 'center'
            }}>
              학적사항 특기사항 기재 예시
            </h2>

            <div style={{
              padding: '24px',
              backgroundColor: '#fff',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <p style={{
                fontSize: '14px',
                color: '#374151',
                lineHeight: '1.8',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap'
              }}>
{`[학교폭력예방 및 대책에 관한 법률 제17조에 따른 조치사항]

• 4호 조치 예시:
학교폭력예방법 제17조제1항제4호에 의한 
사회봉사(○○시간) (20XX.XX.XX)

• 6호 조치 예시:
학교폭력예방법 제17조제1항제6호에 의한 
출석정지(○일) (20XX.XX.XX ~ 20XX.XX.XX)`}
              </p>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section style={{
          padding: '60px 20px',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#111',
            marginBottom: '32px',
            textAlign: 'center'
          }}>
            자주 묻는 질문
          </h2>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
            {faqItems.map((item, idx) => (
              <div key={idx} style={{
                padding: '20px',
                backgroundColor: '#f8fafc',
                borderRadius: '12px'
              }}>
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#111',
                  marginBottom: '12px'
                }}>
                  Q. {item.q}
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#475569',
                  lineHeight: '1.7',
                  margin: 0
                }}>
                  A. {item.a}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section style={{
          padding: '80px 20px',
          textAlign: 'center',
          background: 'linear-gradient(180deg, #fff 0%, #eff6ff 100%)'
        }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#111',
              marginBottom: '16px'
            }}>
              학폭 기재 문구,<br />
              <span style={{ color: '#3182f6' }}>AI가 정확하게</span>
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#64748b',
              lineHeight: '1.7',
              marginBottom: '32px'
            }}>
              조치 유형만 선택하면<br />
              기재요령에 맞는 문구를 <strong>자동 생성</strong>해드립니다.
            </p>

            <button
              onClick={() => navigate('/create-saenggibu')}
              style={{
                padding: '16px 40px',
                fontSize: '16px',
                fontWeight: '600',
                color: '#fff',
                backgroundColor: '#3182f6',
                border: 'none',
                borderRadius: '12px',
                cursor: 'pointer'
              }}
            >
              AI 생기부 작성하기
            </button>
          </div>
        </section>

        {/* 관련 가이드 */}
        <section style={{
          padding: '40px 20px',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#111',
            marginBottom: '16px'
          }}>
            관련 가이드
          </h3>
          
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px'
          }}>
            <Link to="/guide/saenggibu-2026" style={{
              padding: '12px 20px',
              backgroundColor: '#f1f5f9',
              borderRadius: '8px',
              color: '#334155',
              textDecoration: 'none',
              fontSize: '14px'
            }}>
              2026 생기부 기재요령
            </Link>
            <Link to="/guide/setak-example" style={{
              padding: '12px 20px',
              backgroundColor: '#f1f5f9',
              borderRadius: '8px',
              color: '#334155',
              textDecoration: 'none',
              fontSize: '14px'
            }}>
              세특 예시 모음
            </Link>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default HakpokGijaeGuidePage;
